import sx from 'utils/createSx';

export default sx({
  headerContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 99,
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme => theme.spacing(1),
    minHeight: theme => theme.spacing(7),
  },
  icon: {
    height: theme => theme.spacing(3.75),
    width: theme => theme.spacing(3.75),
  },
  menuTitleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
    flex: 1,
    minWidth: 0,
  },
  routeTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'inherit',
  },
});
